module.exports = __webpack_public_path__ + "img/pen-nib.8cd40902.svg";